module.exports = __webpack_public_path__ + "img/port.1846f645.png";